/***
 *Â @FileName: åæ¢è´¦æ·
 *Â @Author: manyao.zhu
 *Â @Date: 2020-06-16 09:16:32
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NzMessageService } from 'ng-zorro-antd';

import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { preventBubble } from '@ithinkdt/shared/utils';
import { API, ChangeAccountService } from '@ithinkdt/theme/fetch-service';
import { AccountInfo } from '@ithinkdt/theme/models';

import { DEFAULT_USER_AVATAR } from './feishu-default-user-avatar';

@Component({
  selector: 'dt-feishu-account',
  templateUrl: './feishu-account.component.html',
  styleUrls: ['./feishu-account.component.scss'],
})
export class FeishuAccountComponent implements OnInit {
  // å±ç¤ºåæ¢è´¦å·çå¼¹çª
  showDialog = false;
  // è´¦å·åè¡¨
  accountList: AccountInfo[] = [];
  // æå­ç§æ·Id
  temporaryTenantId: any;
  // å½åè´¦å·
  currentAccount: string;

  constructor(
    private settingSrv: SettingsService,
    private changeAccountSrv: ChangeAccountService,
    private i18nSrv: I18NService,
    private messageSrv: NzMessageService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAccountList();
  }

  // è¿å»ç§æ·åè¡¨æ°æ®
  getAccountList() {
    this.changeAccountSrv.getAccountList().subscribe((res) => {
      if (res.status) {
        this.accountList = this.handleNoSelectId(res.data);
      }
    });
  }

  // åæ¢è´¦å·çå¤ç
  handleNoSelectId(data) {
    data.map((t) => {
      t.logo = t.logo
        ? `${this.settingSrv.userConfig.env.serverName.file}${API.downloadImageByPubUrl}${t.logo}`
        : DEFAULT_USER_AVATAR;

      if (t.selected) {
        this.currentAccount = t.tenantName;
      }
    });
    return data;
  }

  // åæ¢è´¦å·
  changeAccount() {
    this.showDialog = true;
  }

  // è®¾ç½®é»è®¤è´¦æ·
  settingDefult(data, evt) {
    this.changeAccountSrv.settingDefaultAccount({ tenantId: data.tenantId }).subscribe((res) => {
      if (res.status) {
        this.messageSrv.success(this.i18nSrv.interpret('account.settingSuccess'));
        this.getAccountList();
      }
    });
    // é²æ­¢åæ³¡
    preventBubble(evt);
  }

  // åæ¢è´¦æ·
  exchangeAccount(index) {
    this.accountList.map((t, i) => {
      if (index === i) {
        t.selected = true;
        this.temporaryTenantId = t.tenantId;
      } else {
        t.selected = false;
      }
    });
  }

  // åæ¶äºä»¶
  close() {
    this.showDialog = false;
  }

  // ç¡®å®æ¶é´
  handleOk() {
    const selected = this.accountList.filter((t) => {
      if (t.selected) {
        return t.tenantName;
      }
    });
    this.changeAccountSrv.exchangeAccount({ tenantId: this.temporaryTenantId }).subscribe((res) => {
      if (res.status) {
        this.messageSrv.success(this.i18nSrv.interpret('account.exchangeSuccess'));
        this.close();
        this.router.navigate(['/change-account'], { queryParams: { token: res.data } });
      }
    });
  }
}
